module.exports = __webpack_public_path__ + "img/books-stack-of-three.89909ef2.svg";